import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { replaceSmartQuotes } from "../../utils/procurementForm.utils";

export default function CriterionScoreEditor({
  criterion,
  entry,
  errorScore,
  errorDetail,
  onChangeScore,
  onBlurScore,
  onChangeDetail,
  onBlurDetail,
}) {
  const max = Number.isFinite(criterion.weightingRate) ? criterion.weightingRate : 100;

  const handlePaste = (e) => {
    let html = e.content;
    html = replaceSmartQuotes(html);
    html = html.replace(/(\r?\n){2,}/g, "\n");
    e.content = html;
  };

  return (
    <div className="border rounded p-3 bg-white">
      <div className="font-medium">Critère - <span className="text-blue-600">{criterion.label}</span> -</div>

      <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="md:max-w-[420px]">
          <label className="block mb-2 text-sm font-medium">Score <span className="text-red-500">*</span></label>
          <p className="text-sm text-gray-500">
            Score attendu entre 0 et {criterion.weightingRate ?? 100}
          </p>
          <input
            type="text"
            inputMode="numeric"
            min={0}
            max={max}
            value={entry.score}
            onChange={e => onChangeScore(criterion.id, "score", e.target.value)}
            onBlur={() => onBlurScore(`scores.${criterion.id}.score`)}
            className={`w-full border rounded p-2 ${errorScore ? "border-red-500" : "border-gray-300"}`}
            placeholder={`0 - ${max}`}
          />
          {errorScore && <p className="text-red-600 text-sm mt-1">{errorScore}</p>}
        </div>
      </div>

      <div className="mt-3">
        <label className="block mb-2 text-sm font-medium">Détail <span className="text-red-500">*</span></label>
        <div className={errorDetail ? "border border-red-500 rounded" : ""}>
          <Editor
            apiKey="tdmkfcmx36wjtguc5w8kcc91k37keduhkcroi36btoigb6wp"
            value={typeof entry.detail === "string" ? entry.detail : ""}
            onEditorChange={newContent => onChangeDetail(criterion.id, "detail", newContent)}
            init={{
              height: 320,
              menubar: false,
              plugins: "link visualblocks lists",
              toolbar: "bold italic underline strikethrough | link | bullist numlist | removeformat",
              toolbar_mode: "sliding",
              paste_as_text: false,
              paste_remove_styles: true,
              paste_webkit_styles: "",
              width: "100%",
              language: "fr_FR",
              statusbar: true,
              branding: false,
              elementpath: false,
              resize: true,
              placeholder: "Justification du score (points forts/faiblesses, preuves, etc.)",
              setup: (editor) => {
                editor.on("PastePreProcess", handlePaste);
                editor.on("focusout", () => onBlurDetail(`scores.${criterion.id}.detail`));
              },
            }}
          />
        </div>
        {errorDetail && <p className="text-red-600 text-sm mt-1">{errorDetail}</p>}
      </div>
    </div>
  );
}
